import { Badge, Button, Dropdown, Flex, message, Space, Table, Tag, Tooltip } from "antd";
import TableAntd from "components/elements/Table/Table";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { ReactComponent as DocumentIcon } from "../../assets/icon/documentRound.svg";
import { ReactComponent as ClockingIcon } from "../../assets/icon/clockingIcon.svg";
import { ReactComponent as OtDocument } from "../../assets/icon/otdocument.svg";
import { ReactComponent as CtimeDocument } from "../../assets/icon/ctimedocument.svg";
import { ReactComponent as OffSiteWorkDocument } from "../../assets/icon/offSiteworkdocument.svg";
import ModalWorkinClockingIn from "components/elements/Modal/ModalWorkinClockingIn";
import WorkinStatus from "components/elements/TagCustom/WorkinStatus";

import {
  MY_REQUEST_TYPE
} from "../../features/myDocument/schemas/myRequestSchema";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { useState } from "react";
import SupervisorRequestOtModal from "features/employee/components/SupervisorRequestOtModal";
import { useParams } from "react-router-dom";
import { txnTimeAttendanceEdit } from "features/employee/services/employeeApi";

function tagByStatus(status) {
  switch (status) {
    case "Normal":
      return (<Badge color="#12B76A" text={status} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", color: "#027A48" }} />)
    case "ปกติ":
      return (<Badge color="#12B76A" text={status} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", color: "#027A48" }} />)

    case "Absent":
      return (<Badge color="#F15046" text={status} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", color: "#F15046" }} />)
    case "ขาดงาน":
      return (<Badge color="#F15046" text={status} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", color: "#F15046" }} />)

    case "Late":
      return (<Badge color="#FFBF1A" text={status} style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", color: "#FFBF1A" }} />)
    case "เข้างานสาย":
      return (<Badge color="#FFBF1A" text={status} style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", color: "#FFBF1A" }} />)

    case "ลางาน":
      return (<Badge color="#F1620F" text={status} style={{ backgroundColor: "#FFF5EA", borderRadius: "16px", padding: "2px 8px", color: "#F1620F" }} />)
    case "Leave":
      return (<Badge color="#F1620F" text={status} style={{ backgroundColor: "#FFF5EA", borderRadius: "16px", padding: "2px 8px", color: "#F1620F" }} />)

    case "วันหยุด":
      return (<Badge color="#667085" text={status} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
    case "Holiday":
      return (<Badge color="#667085" text={status} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)

    default:
      return (<Badge color="#667085" text={status} style={{ backgroundColor: "#E1E1E1", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
  }
}

const EmployeeWorkInWorkInTable = ({
  isLoading = false,
  dataSource = [],
  visible = false,
  modalData = {},
  handle = () => { },
  // getMyRequest = () => { },
  onView = () => { },
  handleMenuChange = () => { },
  getWorkInList = () => { },
  getMyoffSiteRequest = () => { },
  getOtRequest = () => { },
  getEndorseTimeRequest = () => { },
  selectedRowKeys = [],
  onChange = () => { },
  showModalClocking = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language == "en" ? "En" : ""
  function formatDate(dateString, pattern = "YYYY-MM-DD") {
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return i18n.language == "en" ? date.format("DD/MM/YYYY") : date.format("DD/MM/BBBB");
  }
  const params = useParams()

  const [onEdit, setOnEdit] = useState(false)
  const [selectData, setSelectData] = useState({})
  function dataSelectedEdit(params) {
    console.log("params", params);
    setSelectData({
      startDate: params.date,
      selectedDateTime: params.checkInTime,
      selectedDateTimeEnd: params.checkOutTime
    })
  }
  function convertMinuteToTimeFormat(minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const formattedMinutes = String(remainingMinutes).padStart(2, '0');

    // If hours is 0, return only the minutes
    if (hours === 0) {
      if (remainingMinutes < 1) {
        return i18n.language === 'en' ? "0 minutes" : "0 นาที";
      } else {
        return i18n.language === 'en' ? `${formattedMinutes} minutes` : `${formattedMinutes} นาที`;
      }
    } else {

      // Format hours to always have two digits
      const formattedHours = String(hours).padStart(2, '0');
      // Return the formatted time
      return i18n.language === 'en' ? `${formattedHours} hour ${formattedMinutes} minutes` : `${formattedHours} ชั่วโมง ${formattedMinutes} นาที`;

    }

  }

  function formatTime(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "HH:mm" : `HH:mm น.`);
  }

  async function editTimeAtt(data) {
    // console.log("params.id", params.id, data);
    // YYYY-MM-DDT00:00:00
    const request = {
      employeeId: params.id,
      startDate: data?.editDate?.format("YYYY-MM-DD"),
      startDateTime: data?.startTime?.format("HH:mm:ss"),
      endDateTime: data?.endTime?.format("HH:mm:ss")
    }
    let dataResp = await txnTimeAttendanceEdit(request);
    message.success(t("common.success"))
    getWorkInList()
  }

  const columns = [
    {
      title: <div className="text-table">{t('workin.date')}</div>,
      dataIndex: "date",
      key: "date",
      align: "center",
      width: "200px",
      render: (_, record) => {
        if (record?.date === null || record?.date === undefined || record?.date === "") {
          return "-";
        }
        return <span
          style={{
            color: "#42526D",
            backgroundColor: "#F5F6F7",
            borderRadius: "20px",
            width: "max-content",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            padding: "8px 16px"
          }}
        >
          {formatDate(record?.date)}
        </span>;
      },
    },
    {
      title: <div className="text-table">{t('workin.shift-name')}</div>,
      dataIndex: "shiftName",
      key: "shiftName",
      align: "center",
      width: "300px",
      render: (_, record) => {
        return (<>
          <div className="text-table">{record?.shiftName}</div>
          <div className="text-table">{record?.workInDateStart ?? "-"} {t("unit.to")} {record?.workInDateEnd ?? "-"}</div>
        </>
        )

      }
    },
    {
      title: <div className="text-table">{t('workin.time-in')}</div>,
      dataIndex: "checkInTime",
      key: "checkInTime",
      align: "center",
      width: "150px",
      render: (_, record) => {
        return record?.checkInTime ? formatTime(record?.checkInTime) : "-"
      }
    },
    {
      title: <div className="text-table">{t('workin.time_out')}</div>,
      dataIndex: "checkOutTime",
      key: "checkOutTime",
      align: "center",
      width: "150px",
      render: (_, record) => {
        return record?.checkOutTime ? formatTime(record?.checkOutTime) : "-"
      }
    },
    {
      title: <div className="text-table">{t('workin.work-time')}</div>,
      dataIndex: "workTime",
      key: "workTime",
      align: "center",
      width: "250px",
      render: (_, record) => {
        return record?.workTime ? convertMinuteToTimeFormat(record?.workTime) : "-"
      }
    },
    {
      title: <div className="text-table">{t('workin.late')}</div>,
      dataIndex: "late",
      key: "late",
      align: "center",
      width: "150px",
      render: (_, record) => {
        if (record?.late == null) {
          return (
            <span>-</span>
          )
        }
        return record?.late === '0' ? record?.late + " " + t("unit.minute_0") : record?.late + " " + t("unit.minute_0")
      }
      // render: (_, record) => {
      //   return formatTimes(record?.late)
      // }
    },
    // {
    //   title: <div className="text-table">Early</div>,
    //   dataIndex: "early",
    //   key: "early",
    // },
    // {
    //   title: <div className="text-table">Absent</div>,
    //   dataIndex: "absent",
    //   key: "absent",
    // },
    {
      title: <div className="text-table">{t('workin.leave_early')}</div>,
      dataIndex: "early",
      key: "early",
      align: "center",
      width: "150px",
      render: (_, record) => {
        if (record?.early == null) {
          return (
            <span>-</span>
          )
        }
        return record?.early === '0' ? record?.early + " " + t("unit.minute_0") : record?.early + " " + t("unit.minute_0")
      }
    },
    {
      title: <div className="text-table">{t('workin.status')}</div>,
      dataIndex: "status",
      key: "status",
      align: "center",
      width: "300px",
      render: (_, record) => {
        return record?.status ? <WorkinStatus value={record?.["status" + language]} /> : "-"
      }
    },
    {
      title: <div className="text-table">{t('workin.ot_report')}</div>,
      dataIndex: "ot",
      key: "ot",
      align: 'center',
      width: "150px",

      render: (_, record) => {
        const workData = record?.works || [];
        const filteredData = workData.filter(item => item.type?.toLowerCase() === "overtime");

        if (filteredData.length === 0) {
          return <span>-</span>;
        }

        return (
          <div>
            {filteredData.map((item, index) => (
              <div key={index}>
                {item.workTime ?? "N/A"} {t('unit.hours')} x {item.otRate ?? "N/A"}
              </div>
            ))}
          </div>
        );
      }
    },
    {
      title: <div className="text-table">{t('workin.document')}</div>,
      dataIndex: "documentType",
      key: "documentType",
      align: 'center',
      width: "300px",
      render: (_, record) => {
        return (
          <>
            <Flex >
              {
                (record?.offSiteWorkDocument) ||
                  (record?.leaveDocument) ||
                  (record?.otDocument) ||
                  (record?.endorseTimeDocument) ? (
                  <>
                    {record?.offSiteWorkDocument && (
                      <Button
                        type="link"
                        icon={<OffSiteWorkDocument />}
                        onClick={() => {
                          handleMenuChange(MY_REQUEST_TYPE.OFFSITE_WORK)
                          onView({ offsiteWorkRequestId: record?.offSiteWorkDocument?.id }, MY_REQUEST_TYPE.OFFSITE_WORK)
                        }
                        }
                      />
                    )}
                    {record?.leaveDocument && (
                      record?.leaveDocument?.map?.(o => {
                        return <Tooltip title={o.sequence}>
                          <Button
                            type="link"
                            icon={<DocumentIcon />}
                            onClick={() => {
                              handleMenuChange(MY_REQUEST_TYPE.LEAVE)
                              onView({ leaveRequestId: o?.id }, MY_REQUEST_TYPE.LEAVE)
                              // getMyRequest(record?.leaveDocument?.id)
                              // getModal(visible, true, modalData)
                            }}
                          />
                        </Tooltip>
                      })
                    )}
                    {record.otDocument && (
                      <Button
                        type="link"
                        icon={<OtDocument />}
                        onClick={() => {
                          handleMenuChange(MY_REQUEST_TYPE.OVERTIME)
                          onView({ overtimeRequestId: record?.otDocument?.id }, MY_REQUEST_TYPE.OVERTIME)
                          // handleMenuChange
                          // getOtRequest(record?.otDocument?.id)
                        }}
                      />
                    )}
                    {record?.endorseTimeDocument && (
                      <Button
                        type="link"
                        icon={<CtimeDocument />}
                        onClick={() => {
                          handleMenuChange(MY_REQUEST_TYPE.ENDORSE_TIME)
                          onView({ endorseTimeRequestId: record?.endorseTimeDocument?.id, endorseMentDate: record?.date }, MY_REQUEST_TYPE.ENDORSE_TIME)
                          // getMyoffSiteRequest(record?.redeemTimeDocument?.id)
                        }}
                      // onClick={() => getEndorseTimeRequest(record?.redeemTimeDocument?.id)}
                      />
                    )}
                  </>
                ) :
                  // (
                  //   <Button
                  //     type="link"
                  //     icon={<DocumentIcon style={{ opacity: 0.5 }} />}
                  //     onClick={() => console.log('No Document')}
                  //   />
                  // )
                  null
              }
            </Flex>
          </>
        );
      }
    },
    {
      title: <div className="text-table">{t('workin.clocking_in')}</div>,
      dataIndex: "clockingIn",
      key: "clockingIn",
      align: 'center',
      width: "200px",

      render: (_, record) => {

        return (
          <>
            {
              record?.timeAttendacehave && record?.timeAttendacehave === "Y" ?
                <Button
                  type="link"
                  icon={<ClockingIcon />}
                  onClick={() => { showModalClocking(record) }}
                />
                :
                null
              // <Button
              //   type="link"
              //   icon={<ClockingIcon style={{ opacity: 0.5 }} />}
              // // onClick={() => { showModalClocking() }}
              // />
            }
          </>
        )

      }
    },
    {
      key: "action",
      align: "center",
      width: 90,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => {
                    setOnEdit(true)
                    dataSelectedEdit(record)
                  },
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                // roles.includes("DELETE_CONFIGURATION|COMMON_MASTER|ATTACHMENT_TYPE") && {
                //   key: "2",
                //   onClick: () => onDelete(record),
                //   label: `${t("action.delete")}`,
                //   icon: (
                //     <DeleteOutlined
                //       style={{ fontSize: "18px", color: "gray" }}
                //     />
                //   ),
                // },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <SupervisorRequestOtModal selectedDate={selectData.startDate}
        selectedDateTime={selectData.selectedDateTime}
        selectedDateTimeEnd={selectData.selectedDateTimeEnd}
        selected={"editWork"}
        isOpen={onEdit}
        onClose={() => { setOnEdit(false); setSelectData({}) }}
        onSubmit={editTimeAtt} />
      <TableAntd
        loading={isLoading}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        scroll={{ x: 'max-content' }}
        rowKey={(record) => record.id}
      // rowSelection={{
      //   type: "checkbox",
      //   selectedRowKeys,
      //   onChange: (values) => {
      //     onChange(values);
      //   },
      //   getCheckboxProps: (record) => {
      //     return { value: record.value };
      //   },
      // }}
      />
    </div>
  );
};

export default EmployeeWorkInWorkInTable;
